import { render, staticRenderFns } from "./CPager.vue?vue&type=template&id=1d11d018&"
import script from "./CPager.vue?vue&type=script&lang=ts&"
export * from "./CPager.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports